var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Currency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-Currency",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7250",
    "data-name": "Rectangle 7250",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M0,15.832V17.5C0,18.877,3.324,20,7.5,20c4.105,0,7.5-1.123,7.5-2.5V15.83c-1.609,1.139-4.562,1.67-7.5,1.67S1.611,16.969,0,15.832ZM12.5,5C16.605,5,20,3.877,20,2.5S16.641,0,12.5,0C8.324,0,5,1.123,5,2.5S8.324,5,12.5,5ZM0,11.734V13.75c0,1.377,3.324,2.5,7.5,2.5,4.105,0,7.5-1.123,7.5-2.5V11.734c-1.609,1.328-4.566,2.016-7.5,2.016S1.611,13.063,0,11.734Zm16.25.43C18.488,11.727,20,10.93,20,10V8.328a9.513,9.513,0,0,1-3.75,1.348ZM7.5,6.25C3.324,6.25,0,7.648,0,9.375S3.324,12.5,7.5,12.5c4.105,0,7.5-1.4,7.5-3.125S11.605,6.25,7.5,6.25Zm8.563,2.2C18.41,8.027,20,7.2,20,6.25V4.578a12.728,12.728,0,0,1-6.281,1.636A4.359,4.359,0,0,1,16.063,8.445Z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Currency);
export default __webpack_public_path__ + "static/media/icon-24-Currency.7854cfb21768689a299efff03d52fa00.svg";
export { ForwardRef as ReactComponent };